import {isMobile} from '@/utils/features';

export default function (dom, opts) {
    let options = {
        acceptSel: '[data-accept]',

        ...opts
    };


    function init() {
        ifMobile()
    }

    function ifMobile() {
        if (isMobile()) {
            location.href = 'https://m.refline.ch/302831/search.html';
        }
    }


    init()

}
